import React from 'react';

export interface FanSpeedStyle02Props {
  value?: string;
  options: string[] | string;  // Accept both array and comma-separated string
  disabled?: boolean;
  loading?: boolean;
  onChange: (value: string) => void;
  label?: string;
  labels?: Record<string, string>;
}

const DEFAULT_SPEEDS = ['auto', 'low', 'medium', 'high'];

/**
 * FanSpeed Style 02 - Pills
 * Horizontal pill-shaped buttons for fan speed selection
 */
export const Style02_Pills: React.FC<FanSpeedStyle02Props> = ({
  value,
  options: rawOptions,
  disabled = false,
  loading = false,
  onChange,
  label = '風速',
  labels = { '1': '低速', '2': '中速', '3': '高速', '4': '速度 4', 'low': '低速', 'medium': '中速', 'high': '高速', 'auto': '自動' }
}) => {
  // Ensure options is always an array (handle string input)
  const options = Array.isArray(rawOptions) 
    ? rawOptions 
    : (typeof rawOptions === 'string' ? rawOptions.split(',').map(s => s.trim()) : DEFAULT_SPEEDS);

  return (
    <div className="space-y-3">
      <span className="text-sm text-slate-300">{label}</span>
      <div className="flex gap-2">
        {options.map((option) => {
          const isSelected = value === option;
          return (
            <button
              key={option}
              onClick={() => onChange(option)}
              disabled={disabled || loading}
              className={`flex-1 py-2.5 px-3 rounded-full text-sm font-medium transition-all ${
                isSelected
                  ? 'bg-blue-500 text-white'
                  : 'bg-slate-700/50 text-slate-400 hover:bg-slate-600/50'
              } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
            >
              {loading && isSelected ? '...' : labels[option] || option}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Style02_Pills;
